import { VStack, Text, Divider } from '@chakra-ui/react';

import Const from '../Constants';

/*
  A labelled settings group: a divider, an optional uppercase heading, then a
  vertical stack of SettingsRow children. Adding a new settings group is just
  another <SettingsSection label="…"> with rows inside.
*/
const SettingsSection = ({ label, children }) => {
  return (
    <VStack align={'stretch'} w={'100%'} spacing={Const.SpaceSM}>
      <Divider borderColor={Const.Gray100} />

      {label && (
        <Text
          fontSize={Const.XS}
          fontWeight={Const.Bold}
          color={Const.Gray165}
          letterSpacing={'0.08em'}
          textTransform={'uppercase'}
        >
          {label}
        </Text>
      )}

      <VStack align={'stretch'} w={'100%'} spacing={Const.SpaceSM}>
        {children}
      </VStack>
    </VStack>
  );
};

export default SettingsSection;
